/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, Grid, SortableLabel, SortDirection, Text, Theme, useTheme } from 'bold-ui'
import { useMemo } from 'react'

export interface HistoricoAtendimentoTableHeader {
  sort?: SortDirection
  onSortChange?(sort: SortDirection): void
}

export default function HistoricoAtendimentoTableHeader(props: HistoricoAtendimentoTableHeader) {
  const { sort, onSortChange } = props
  const theme = useTheme()
  const classes = useMemo(() => styles(theme), [theme])

  const dataHeaderConfig = {
    name: 'data',
    header: 'Data',
  }

  return (
    <div css={classes.grid}>
      <Grid>
        <Cell size={1} style={css(classes.centerCell, classes.dataCell)}>
          <SortableLabel direction={sort} onChange={onSortChange}>
            <Text fontWeight='bold' style={classes.text}>
              {dataHeaderConfig.header}
            </Text>
          </SortableLabel>
        </Cell>
      </Grid>
    </div>
  )
}

HistoricoAtendimentoTableHeader.defaultProps = {
  sort: null,
  onSortChange: () => null,
}

const styles = (theme: Theme) => ({
  grid: css`
    padding: 1rem;
    border-bottom: 1px solid ${theme.pallete.gray.c80};
  `,
  centerCell: css`
    align-self: center;
  `,
  text: css`
    margin-right: 0.5rem;
  `,
  dataCell: css`
    text-align: center;
  `,
  imprimirButtonCell: css`
    display: inline-flex;
    justify-content: flex-end;
  `,
})
